let config = {};

export const setEnvironmentConfig = (env) => {
  config = env;
};

export const getEnvironmentConfig = () => config;

export const getEnvironmentVariable = (key) => {
  let configValueFound = null;

  // search for overridden config from .env file first
  if (process.env[`REACT_APP_${key}`]) {
    configValueFound = process.env[`REACT_APP_${key}`];
  } else if (config && config[key]) {
    configValueFound = config[key];
  }

  return configValueFound;
};

export default {
  setEnvironmentConfig,
  getEnvironmentConfig,
  getEnvironmentVariable,
};
